// removed by extract-text-webpack-plugin
module.exports = {"PaymentType":"PaymentType__PaymentType__3TZrD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Order/PaymentType/PaymentType.css
// module id = 248
// module chunks = 1